import { useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { auth } from '../services/supabase'
import toast from 'react-hot-toast'

const C = { mint: '#00C896', text: '#E8F5EE', muted: '#6B8F7A', border: '#1E2E24', surface: '#111916', bg: '#0A0F0D' }

export default function Login() {
  const [mode, setMode] = useState('login') // 'login' | 'signup'
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const [params] = useSearchParams()
  const redirect = params.get('redirect') || '/dashboard'

  const handleSubmit = async () => {
    if (!email || !password) { toast.error('Please fill in all fields'); return }
    setLoading(true)
    try {
      if (mode === 'signup') {
        const { error } = await auth.signUp(email, password)
        if (error) throw error
        toast.success('Account created! Check your email to verify.')
      } else {
        const { error } = await auth.signIn(email, password)
        if (error) throw error
        toast.success('Welcome back!')
        navigate(redirect)
      }
    } catch (err) {
      toast.error(err.message || 'Something went wrong')
    }
    setLoading(false)
  }

  return (
    <div style={{ minHeight: '100vh', background: C.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ width: '100%', maxWidth: 400 }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <a href="/" style={{ display: 'inline-flex', alignItems: 'center', gap: 10, textDecoration: 'none' }}>
            <div style={{ width: 40, height: 40, borderRadius: 12, background: C.mint, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22, boxShadow: '0 0 20px rgba(0,200,150,0.35)' }}>🌿</div>
            <span style={{ fontFamily: 'Syne, sans-serif', fontWeight: 800, fontSize: 22, color: C.text }}>
              Peppermint<span style={{ color: C.mint }}>Fi</span>
            </span>
          </a>
        </div>

        <div style={{ background: C.surface, border: `1px solid ${C.border}`, borderRadius: 20, padding: 36 }}>
          <h2 style={{ fontFamily: 'Syne, sans-serif', color: C.text, fontSize: 22, fontWeight: 700, marginBottom: 8, textAlign: 'center' }}>
            {mode === 'login' ? 'Welcome back' : 'Create your account'}
          </h2>
          <p style={{ color: C.muted, fontSize: 14, textAlign: 'center', marginBottom: 28 }}>
            {mode === 'login' ? 'Sign in to your PeppermintFi account' : 'Start managing your money smarter'}
          </p>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <input
              type="email" value={email} onChange={e => setEmail(e.target.value)}
              placeholder="Email address"
              style={{ background: '#161F1A', border: `1px solid ${C.border}`, borderRadius: 12, padding: '13px 16px', color: C.text, fontSize: 14, outline: 'none', fontFamily: 'DM Sans, sans-serif' }}
            />
            <input
              type="password" value={password} onChange={e => setPassword(e.target.value)}
              placeholder="Password" onKeyDown={e => e.key === 'Enter' && handleSubmit()}
              style={{ background: '#161F1A', border: `1px solid ${C.border}`, borderRadius: 12, padding: '13px 16px', color: C.text, fontSize: 14, outline: 'none', fontFamily: 'DM Sans, sans-serif' }}
            />
            <button onClick={handleSubmit} disabled={loading} style={{
              background: C.mint, border: 'none', borderRadius: 12, padding: '14px',
              color: '#000', fontFamily: 'Syne, sans-serif', fontSize: 15, fontWeight: 700,
              cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1,
              transition: 'all 0.15s',
            }}>
              {loading ? 'Please wait...' : mode === 'login' ? 'Sign In' : 'Create Account'}
            </button>
          </div>

          {mode === 'login' && (
            <div style={{ textAlign: 'right', marginTop: -6, marginBottom: 10 }}>
              <button onClick={async () => {
                if (!email) { toast.error('Enter your email first'); return; }
                const { error } = await import('../services/supabase').then(m => m.auth.resetPassword(email));
                if (error) toast.error(error.message);
                else toast.success('Password reset email sent!');
              }} style={{
                color: C.muted, background: 'none', border: 'none',
                fontSize: 13, cursor: 'pointer', fontFamily: 'DM Sans, sans-serif'
              }}>Forgot your password?</button>
            </div>
          )}
          <div style={{ textAlign: 'center', marginTop: 20 }}>
            <span style={{ color: C.muted, fontSize: 14 }}>
              {mode === 'login' ? "Don't have an account? " : 'Already have an account? '}
            </span>
            <button onClick={() => setMode(mode === 'login' ? 'signup' : 'login')} style={{
              color: C.mint, background: 'none', border: 'none', fontSize: 14,
              cursor: 'pointer', fontFamily: 'DM Sans, sans-serif', fontWeight: 600,
            }}>
              {mode === 'login' ? 'Sign up free' : 'Sign in'}
            </button>
          </div>
        </div>

        <p style={{ color: C.muted, fontSize: 12, textAlign: 'center', marginTop: 20 }}>
          By continuing you agree to our Terms of Service and Privacy Policy.
        </p>
      </div>
    </div>
  )
}
